import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

export default {
  props: {
    hsv: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  data: function data() {
    return {
      slideHueStyle: {}
    };
  },

  // 不能监听，否则操作saturation时，这里的slide会抖动
  // watch: {
  //     'hsv.h'() {
  //         this.renderSlide()
  //     }
  // },
  mounted: function mounted() {
    this.renderColor();
    this.renderSlide();
  },

  methods: {
    renderColor: function renderColor() {
      var canvas = this.$refs.canvasHue;
      var width = this.width;
      var height = this.height;
      var ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;

      var gradient = ctx.createLinearGradient(0, 0, 0, height);
      gradient.addColorStop(0, '#FF0000'); // 红
      gradient.addColorStop(0.17 * 1, '#FF00FF'); // 紫
      gradient.addColorStop(0.17 * 2, '#0000FF'); // 蓝
      gradient.addColorStop(0.17 * 3, '#00FFFF'); // 青
      gradient.addColorStop(0.17 * 4, '#00FF00'); // 绿
      gradient.addColorStop(0.17 * 5, '#FFFF00'); // 黄
      gradient.addColorStop(1, '#FF0000'); // 红
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
    },
    renderSlide: function renderSlide() {
      this.slideHueStyle = {
        top: (1 - this.hsv.h / 360) * this.height - 2 + 'px'
      };
    },
    selectHue: function selectHue(e) {
      var _this = this;

      var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
          hueTop = _$el$getBoundingClien.top;

      var ctx = e.target.getContext('2d');

      var mousemove = function mousemove(e) {
        var y = e.clientY - hueTop;

        if (y < 0) {
          y = 0;
        }
        if (y > _this.height) {
          y = _this.height;
        }

        _this.slideHueStyle = {
          top: y - 2 + 'px'
          // 如果用最大值，选择的像素会是空的，空的默认是黑色
        };var imgData = ctx.getImageData(0, Math.min(y, _this.height - 1), 1, 1);

        var _imgData$data = _slicedToArray(imgData.data, 3),
            r = _imgData$data[0],
            g = _imgData$data[1],
            b = _imgData$data[2];

        _this.$emit('selectHue', { r: r, g: g, b: b });
      };

      mousemove(e);

      var mouseup = function mouseup() {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    }
  }
};